export const FLARE_BG = '/images/background/flare.webp';

export const DOTTED_SVG =
  'data:image/svg+xml,<svg height="32" width="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><circle r="2" cx="2" cy="2" fill="%23fff" fill-opacity="0.05" /></svg>';
